import React, { useState } from 'react';

const translations = {
  ar: {
    title: "تواصل مع خبراء رفاد",
    sub: "للاستفسار عن خدمات التدوير، فريقنا يرد خلال 24 ساعة.",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الجوال",
    message: "نوع المخلفات وكميتها التقريبية...",
    submit: "إرسال الطلب",
    success: "✅ تم إرسال طلبك بنجاح! سيتواصل معك فريقنا قريباً.",
    error: "❌ حدث خطأ في الإرسال. الرجاء المحاولة مرة أخرى",
    fillError: "⚠️ الرجاء تعبئة الاسم والبريد الإلكتروني",
    emailError: "⚠️ الرجاء إدخال بريد إلكتروني صحيح",
    contactInfo: {
      phoneLabel: "اتصل بنا مباشرة",
      emailLabel: "البريد الإلكتروني",
      locationLabel: "موقعنا",
       locationValue: "الرياض، المملكة العربية السعودية",
      hoursValue: "الأحد - الخميس: 9 ص - 6 م"
    }
  },
  en: {
    title: "Contact Rafad Experts",
    sub: "For inquiries about recycling services, our team responds within 24 hours.",
    name: "Full Name",
    email: "Email Address",
    phone: "Phone Number",
    message: "Type and approximate quantity of waste...",
    submit: "Send Request",
    success: "✅ Your request has been sent successfully!",
    error: "❌ An error occurred. Please try again",
    fillError: "⚠️ Please fill in name and email",
    emailError: "⚠️ Please enter a valid email address",
    contactInfo: {
      phoneLabel: "Call Us Directly",
      emailLabel: "Email Address",
      locationLabel: "Our Location",
       locationValue: "Riyadh, Saudi Arabia",
      hoursValue: "Sunday - Thursday: 9 AM - 6 PM"
    }
  }
};

const Contact = ({ currentLang }) => {
  const t = translations[currentLang];
  
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const contactInfo = [
    { 
      icon: "fas fa-phone-alt", 
      label: t.contactInfo.phoneLabel, 
      value: "+966 59 960 4444", 
      dir: "ltr" 
    },
    { 
      icon: "fas fa-envelope", 
      label: t.contactInfo.emailLabel, 
      value: "info@rifadrecycling.sa", 
      dir: "ltr" 
    },
    { 
      icon: "fas fa-map-marker-alt", 
      label: t.contactInfo.locationLabel, 
      value: t.contactInfo.locationValue 
    },
 
  ];

  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email) {
      showNotification(t.fillError, 'error');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showNotification(t.emailError, 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://formspree.io/f/xjgpzboy', {
        method: 'POST',
        body: new FormData(e.target),
        headers: { 'Accept': 'application/json' }
      });
      
      if (response.ok) {
        showNotification(t.success, 'success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else throw new Error();
    } catch (error) {
      showNotification(t.error, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact">
      <h2 className="section-title">{t.title}</h2>
      <p className="section-sub">{t.sub}</p>
      
      <div className="contact-container">
        <div className="contact-info">
          {contactInfo.map((info, index) => (
            <div className="info-card" key={index}>
              <i className={info.icon}></i>
              <div>
                <h4>{info.label}</h4>
                <p style={{ direction: info.dir || 'rtl' }}>{info.value}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <i className="fas fa-user"></i>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder={t.name} required />
            </div>
            <div className="input-group">
              <i className="fas fa-envelope"></i>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder={t.email} required />
            </div>
            <div className="input-group">
              <i className="fas fa-phone"></i>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder={t.phone} />
            </div>
            <div className="input-group">
              <i className="fas fa-comment"></i>
              <textarea rows="4" name="message" value={formData.message} onChange={handleChange} placeholder={t.message}></textarea>
            </div>
            
            <input type="hidden" name="_language" value={currentLang} />
            <input type="hidden" name="_subject" value="طلب جديد من موقع رفاد التدوير" />
            
            <button type="submit" className="btn-submit" disabled={loading}>
              <i className="fas fa-paper-plane"></i>
              <span>{loading ? (currentLang === 'ar' ? 'جاري الإرسال...' : 'Sending...') : t.submit}</span>
            </button>
          </form>
        </div>
      </div>

      {notification && (
        <div className={`notification ${notification.type}`}>
          <i className={`fas ${notification.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
          <span>{notification.message}</span>
        </div>
      )}

      <style>{`
        .contact-container {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 3rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        .contact-info {
          display: grid;
          gap: 1.2rem;
        }
        .info-card {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 1.2rem 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
          border: 1px solid rgba(83, 176, 150, 0.2);
        }
        .info-card i {
          font-size: 2rem;
          color: #53b096;
          width: 50px;
        }
        .info-card div h4 {
          font-size: 1rem;
          color: #6a7a8a;
          margin-bottom: 0.3rem;
        }
        .info-card div p {
          font-size: 1rem;
          font-weight: 700;
          color: #53b096;
        }
        .contact-form {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(12px);
          border-radius: 32px;
          padding: 2rem;
          border: 1px solid rgba(83, 176, 150, 0.2);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .input-group {
          margin-bottom: 1.2rem;
          position: relative;
        }
        .input-group i {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #53b096;
          z-index: 1;
        }
        .input-group textarea + i {
          top: 1.2rem;
          transform: none;
        }
        .input-group input, .input-group textarea {
          width: 100%;
          padding: 1rem 2.8rem 1rem 1rem;
          border-radius: 16px;
          font-family: 'Cairo', sans-serif;
          font-size: 1rem;
          background: #ffffff;
          border: 2px solid rgba(83, 176, 150, 0.2);
          color: #1a2a3a;
        }
        .input-group input:focus, .input-group textarea:focus {
          outline: none;
          border-color: #53b096;
        }
        .btn-submit {
          width: 100%;
          padding: 1rem 2rem;
          border-radius: 50px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border: none;
          cursor: pointer;
          font-size: 1.1rem;
          background: linear-gradient(95deg, #53b096, #71b887);
          color: white;
          font-family: 'Cairo', sans-serif;
        }
        .btn-submit:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(83, 176, 150, 0.2);
        }
        .btn-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .notification {
          position: fixed;
          bottom: 20px;
          right: 20px;
          padding: 15px 25px;
          border-radius: 12px;
          background: white;
          z-index: 1000;
          display: flex;
          align-items: center;
          gap: 12px;
          animation: slideIn 0.3s ease;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
        }
        .notification.success { border-right: 4px solid #53b096; color: #1a2a3a; }
        .notification.error { border-right: 4px solid #e74c3c; color: #1a2a3a; }
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @media (max-width: 900px) {
          .contact-container { grid-template-columns: 1fr; }
          .contact-info { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 600px) {
          .contact-info { grid-template-columns: 1fr; }
          .contact-form { padding: 1.5rem; }
        }
      `}</style>
    </section>
  );
};

export default Contact;